<template>
    <div class="row">
        <div class="col-lg-3 first form-group">
            <label>Current Tags:</label>
            <ul class="no-style list-group">
                <li v-for="tag in tags" class="list-group-item">
                    <span class="btn " @click="removeTag(tag.label)"><i class="fas fa-minus-square red"> </i></span>
                    {{ tag.label }}
                </li>
            </ul>
        </div>
        <div class="col-md-9 last form-group">
            <label class="block">Add Tag:</label>
            <div class="col-md-6 form-group">
                <input
                    type="text"
                    id="freeTag"
                    name="freeTag"
                    placeholder="add tag"
                    ref="input"
                    v-model="freeTag"
                    class="form-control"
                    autocomplete="on"
                    @keyup="showOptions"
                >
                <div class="selectOptions" v-if="this.hasOptions">
                    <ul class="no-style">
                        <li v-for="option in options">
                             <a  class="btn " @click="addOptionTag(option)"><i class="fas fa-plus-square green"> </i>
                                {{option.label}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="form-group"v>
                <span id="addTag" @click="addTag" class="btn btn-success">Add New Tag</span>
            </div>
        </div>
        <input type="hidden" id="free_tags" name="free_tags[]" :value="jsonStringify">
    </div>
</template>

<script>
    /**
    * when starting to type a tag name, we query to see if any current tags match the typed character(s)
    * push those results in a select format showing below the input field
    * if selecting a tag option and saving - push it into the hidden field free_tags[] as string.
    * i.e. '12,32,43'
   */
    export default{
        name:'AutocompleteTag',
        data(){
            return {
               csrfToken : Laravel.csrfToken,
               appUrl : Laravel.appUrl,
               tags : [],
               freeTag: '',
               option : '',
               options: [],
               hasOptions: false
            }
        },
        methods:{
            addTag(){
                if( this.freeTag && this.freeTag.trim() != ''){
                    this.tags.push({
                             label: this.freeTag.trim(),
                             value: 0
                         });
                }
                 // clear out
                this.freeTag = '';
            },
             addOptionTag(option){
                if( option && option.label.trim() != ''){
                    this.tags.push({
                             label: option.label.trim(),
                             value: option.id,
                         });
                }
                // clear out
                this.freeTag = '';
                this.options = [];
                this.hasOptions = false;
            },
            removeTag(freeTag){
                // remove from tags where this tag  == this.freeTag  item.label
                // need to check by label because removing by index would remove all new tags added
                 for (const key of Object.keys(this.tags)) {
                    if (this.tags.hasOwnProperty(key)) {
                        if(this.tags[key]['label'] == freeTag){
                            let index = this.tags.indexOf(this.tags[key])
                            this.tags.splice(index, 1);
                        }
                    }
                 }
            },
            showOptions(){
                if( this.freeTag.trim() ){
                       axios({
                        url: this.appUrl + '/api/freetags/callback',
                        method: 'post',
                        data: { 'tag' : this.freeTag },
                       })
                       .then( response => {
                            if(response.data.length){
                                this.options = response.data;
                                this.hasOptions = true;

                            } else {
                                this.options = [];
                                this.hasOptions = false;
                            }
                         })
                        .catch( error => {
                                console.log('error' ,error);
                        });
                    }
            },
            selectify(prop, options, value, label ){
                // filters data into label-value associations
                // for selects, checkboxes, radios
                if( typeof options === 'object'){
                    for (const key of Object.keys(options)) {
                         prop.push({
                                 label: options[key][label],
                                 value: options[key][value]
                         })
                     }
                }
                if( typeof options === 'array'){
                   options.map(function(item) {
                        prop.push({
                            label: item[label],
                            value: item[value]
                        })
                    });
                }
            },
        },
        computed: {
            jsonStringify: function(){
                 return  JSON.stringify(this.tags);
            }
        },
        mounted(){
            // get the free tags passed through controller
            if (typeof App != 'undefined') {
                if(App.contentFreeTags){
                   // console.table(App.contentFreeTags);
                    this.selectify( this.tags, App.contentFreeTags, 'id', 'name');
                }
            }
        }
    }
</script>

